import { render } from "./ArchivedOrder.vue?vue&type=template&id=d345e10e&scoped=true&ts=true"
import script from "./ArchivedOrder.vue?vue&type=script&lang=ts"
export * from "./ArchivedOrder.vue?vue&type=script&lang=ts"

import "./ArchivedOrder.vue?vue&type=style&index=0&id=d345e10e&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d345e10e"]])

export default __exports__